<template>
  <div class="ViewPromo" ref="container">
    <view-top :title="title" :desc="desc" :id="id"></view-top>
    <view-how-cards class="ViewPromo__section"></view-how-cards>
    <view-promo-products
      :id="id"
      :productId="productId"
      class="ViewPromo__section"
    ></view-promo-products>

    <div class="ViewPromo__section">
      <div class="ViewDieselInfo">
        <div class="ViewDieselInfo__row">
          <div class="ViewDieselInfo__col">
            <div class="ViewDieselInfo__content">
              <h2 class="ViewDieselInfo__title">{{ name }}</h2>
              <div class="ViewDieselInfo__inn">ИНН {{ inn }}</div>
              <div class="ViewDieselInfo__text app-typography">
                <h4>О компании:</h4>
                <p>
                  Мы реализуем широкий спектр светлых и тёмных нефтепродуктов,
                  включая бензины, керосин и дизельное топливо.
                </p>

                <p>
                  Поставки осуществляются напрямую от ведущих
                  нефтеперерабатывающих компаний, таких как Роснефть, Газпром,
                  Лукойл, Татнефть.
                </p>
                <p>
                  Мы специализируемся на оптовой продаже нефтепродуктов,
                  обеспечиваем выгодные условия поставок ГСМ по всей России.
                  Свяжитесь с нашими специалистами для получения подробной
                  информации о нашей продукции и условиях доставки.
                </p>
              </div>
            </div>
          </div>
          <div class="ViewDieselInfo__col">
            <div class="ViewDieselInfo__advantages-wrapper">
              <ul class="ViewPromo__advantages">
                <li class="ViewPromo__advantage">
                  <div class="ViewPromo__advantage-icon">
                    <app-svg-icon
                      name="iphone"
                      class="ViewPromo__advantage-icon-svg"
                    ></app-svg-icon>
                  </div>
                  <div class="ViewPromo__advantage-text">
                    <h4 class="ViewPromo__advantage-title">
                      Данные поставщика
                    </h4>
                    <p>
                      Телефон компании:<br />
                      <strong
                        ><a
                          href="tel:+74912464000"
                          class="ViewPromo__advantage-contact-link"
                          >+7 (4912) 464-000</a
                        ></strong
                      >
                    </p>
                    <p>
                      Адрес электронной почты:<br />
                      <strong
                        ><a
                          href="mailto:info@real-oil.ru"
                          class="ViewPromo__advantage-contact-link"
                          >info@real-oil.ru</a
                        ></strong
                      >
                    </p>
                  </div>
                </li>
                <li class="ViewPromo__advantage">
                  <div class="ViewPromo__advantage-icon">
                    <app-svg-icon
                      name="lock-pin"
                      class="ViewPromo__advantage-icon-svg"
                    ></app-svg-icon>
                  </div>
                  <div class="ViewPromo__advantage-text">
                    <h4 class="ViewPromo__advantage-title">Базисы поставок</h4>
                    <p>НПЗ Саратовский, ЛПДС Никольская, ЛПДС Володарская</p>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>

    <view-oil-scheme class="ViewPromo__section"></view-oil-scheme>
    <view-safe-advantages class="ViewPromo__section"></view-safe-advantages>
    <view-advantages class="ViewPromo__section"></view-advantages>
    <view-landing-buttons class="ViewPromo__section"></view-landing-buttons>
  </div>
</template>

<script>
export default {
  name: 'ViewPromo',
  inject: ['responsive'],
  components: {
    ViewPromoProducts: () =>
      import('@/pages/static/components/ViewPromoProducts.vue'),
    ViewSafeAdvantages: () =>
      import('@/pages/static/components/ViewSafeAdvantages'),
    ViewTop: () => import('@/pages/static/components/ViewTop'),
    ViewAdvantages: () => import('@/pages/static/components/ViewAdvantages'),
    ViewOilScheme: () => import('@/pages/static/components/ViewOilScheme'),
    ViewLandingButtons: () =>
      import('@/pages/static/components/ViewLandingButtons'),
    ViewHowCards: () => import('@/pages/static/components/ViewHowCards'),
    AppSvgIcon: () => import('@/components/common/AppSvgIcon'),
  },
  data: () => ({
    title: 'Топливо оптом онлайн от поставщика ООО «РЕАЛ-ОЙЛ»',
    desc: 'на платформе OPEN OIL MARKET',
    id: 1245,
    productId: 2087,
    name: 'ООО «РЕАЛ-ОЙЛ»',
    inn: '6230090183 ',
  }),
};
</script>
